import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RequestHelpersService } from '../../shared/services/request-helpers.service';
import { HttpClient } from '@angular/common/http';

export interface AuthResponseData {
  access_token: string;
}

export interface SignInCredentials {
  email: string;
  password: string;
}

interface SignUpData {
  name: string;
  email: string;
  password: string;
  accepted_terms: boolean;
  /** Cloudflare Turnstile token; absent while the challenge is unconfigured. */
  turnstile_token?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private signInUrl: string = `${environment.apiUrl}/auth/token`;
  private signUpUrl: string = `${environment.apiUrl}/auth/signup`;
  private headers = this.requestHelpers.createHeaders();

  constructor(
    private http: HttpClient,
    private requestHelpers: RequestHelpersService
  ) { }

  authSignUp(data: SignUpData) {
    return this.http.post<AuthResponseData>(this.signUpUrl, {
      full_name: data.name,
      email: data.email,
      password: data.password,
      accepted_terms: data.accepted_terms,
      // Omitted entirely when absent so the API's log-only mode still accepts
      // the request rather than seeing an explicit empty token.
      ...(data.turnstile_token ? { turnstileToken: data.turnstile_token } : {}),
      ...this.headers,
    });
  }

  authLogin(credentials: SignInCredentials) {
    return this.http.post<AuthResponseData>(this.signInUrl, {
      email: credentials.email,
      password: credentials.password,
      grant_type: 'client_credentials',
    });
  }
}
